"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebGamepadDevice = void 0;
const ButtplugDeviceImpl_1 = require("../../../devices/ButtplugDeviceImpl");
class WebGamepadDevice extends ButtplugDeviceImpl_1.ButtplugDeviceImpl {
    constructor(_device) {
        super(_device.id, _device.index.toString());
        this._device = _device;
        this.Connect = () => __awaiter(this, void 0, void 0, function* () {
            // Noop. We're connected when we're created.
            return Promise.resolve();
        });
        this.Disconnect = () => __awaiter(this, void 0, void 0, function* () {
            // Noop. We don't have to do anything here.
        });
        this.OnDisconnect = () => {
            this._logger.Debug(`WebBluetoothDevice: ${this.constructor.name} disconnecting`);
            this.emit("deviceremoved");
        };
        this.WriteValueInternal = (aValue, aOptions) => __awaiter(this, void 0, void 0, function* () {
            // Somehow, typescript expects pulse, not effect. Surprising since Microsoft
            // went Chromium.
            //
            // For now, assume we'll only have a dual-rumble gamepad. Assume that we've
            // already packed 2 little-endian floats in the protocol. Silly to have to
            // serialize here, but it keeps the system consistency.
            const weakMag = aValue.readFloatLE(0);
            const strongMag = aValue.readFloatLE(4);
            this._gamepad.vibrationActuator.playEffect("dual-rumble", { duration: 1000, startDelay: 0, weakMagnitude: weakMag, strongMagnitude: strongMag });
            return Promise.resolve();
        });
        this.ReadValueInternal = (aOptions) => __awaiter(this, void 0, void 0, function* () {
            // This should never be called.
            return Promise.reject("This should never be called");
        });
        this.SubscribeToUpdatesInternal = (aOptions) => __awaiter(this, void 0, void 0, function* () {
            // This should never be called.
            return Promise.reject("This should never be called");
        });
        this.Unsubscribe = (aOptions) => __awaiter(this, void 0, void 0, function* () {
            // This should never be called.
            return Promise.reject("This should never be called");
        });
        this._gamepad = _device;
        window.addEventListener("gamepaddisconnected", (ev) => {
            if (ev.gamepad.index === this._gamepad.index) {
                this.OnDisconnect();
            }
        });
    }
    get Connected() {
        return this._gamepad.connected;
    }
}
exports.WebGamepadDevice = WebGamepadDevice;
//# sourceMappingURL=WebGamepadDevice.js.map